import { all, call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";

import {} from "./reducer";

function* appSagas() {
  yield all([]);
}

export default appSagas;
